






















import moment from 'moment'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { DashboardBaseItem } from '@/interfaces'
import Progress from '@/components/common/progressBar/Progress.vue'

@Component({
  components: {
    Progress
  }
})
export default class DashboardItem extends Vue {
  @Prop({
    required: true
  })
  type!: string

  @Prop({
    required: true
  })
  title!: string

  @Prop({
    required: true
  })
  item!: DashboardBaseItem

  moment = moment
}
